export default __webpack_public_path__ + "static/media/dreamstime_xs_146058335.782b88ac.jpg";